import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "../Logo";
import {
  about,
  community,
  contact,
  dashboardHome,
  home,
  publicEvents,
  radio,
} from "../../urls";
import LinkButton from "../LinkButton";
import MobileMenuHome from "../MobileMenuHome";
import {
  DesktopHeader,
  HamburgerMenu,
  MobileHeader,
  MobileItemsWrapper,
  NavItem,
} from "../../styles/sharedStyles";
import SpacesNavItem from "./SpacesNavItem";
import styled from "styled-components";
import { colors } from "../../utils/theme";

const HomeNavbar = () => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenu = () => {
    setMenuOpen(!menuOpen);
    document.body.classList.toggle("fixed_body");
  };

  const closeMenu = () => {
    setMenuOpen(false);
    document.body.classList.remove("fixed_body");
  };

  return (
    <>
      <DesktopHeader>
        <HeaderWrapper>
          <div className="row">
            <div className={"col-lg-1 col-6"}>
              <Logo header />
            </div>
            <div className="col-lg-9 col-md-6 col-sm-6 d-none d-lg-block align-self-center">
              <ul className="list-inline text-center">
                <NavItem className="list-inline-item pe-2 ps-2 pe-xl-4 ps-xl-4">
                  <Link to={home}>{t("oostwest")}</Link>
                </NavItem>
                <NavItem className="list-inline-item pe-2 ps-2 pe-xl-4 ps-xl-4">
                  <Link to={about}>{t("about")}</Link>
                </NavItem>
                <SpacesNavItem />
                <NavItem className="list-inline-item pe-2 ps-2 pe-xl-4 ps-xl-4">
                  <Link to={publicEvents}>{t("events")}</Link>
                </NavItem>
                <NavItem className="list-inline-item pe-2 ps-2 pe-xl-4 ps-xl-4">
                  <Link to={community}>{t("community")}</Link>
                </NavItem>
                <NavItem className="list-inline-item pe-2 ps-2 pe-xl-4 ps-xl-4">
                  <Link to={radio}>{t("radio")}</Link>
                </NavItem>
                <NavItem className="list-inline-item pe-2 ps-2 pe-xl-4 ps-xl-4">
                  <Link to={contact}>{t("contact")}</Link>
                </NavItem>
              </ul>
            </div>
            <div className="col-lg-2 col-6 text-right align-self-center align-items-end">
              <LinkButton
                to={dashboardHome}
                type={"outlined"}
                small
                style={{ marginRight: 12 }}
              >
                {t("login")}
              </LinkButton>
              {/*<StyledButton onClick={() => dispatch(toggleHireSpaceModal())}>*/}
              {/*  {t("rent_a_space")}*/}
              {/*</StyledButton>*/}
            </div>
          </div>
        </HeaderWrapper>
      </DesktopHeader>
      <MobileHeader>
        <MobileItemsWrapper>
          <HamburgerMenu
            onClick={() => handleMenu()}
            className={menuOpen ? "active" : ""}
          >
            <span />
            <span />
            <span />
          </HamburgerMenu>
          <Logo header />
          <ProfileLinkButton to={dashboardHome} aria-label={t("login")}>
            <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
              <path d="m437.019531 74.980469c-48.351562-48.351563-112.640625-74.980469-181.019531-74.980469s-132.667969 26.628906-181.019531 74.980469c-48.351563 48.351562-74.980469 112.640625-74.980469 181.019531s26.628906 132.667969 74.980469 181.019531c48.351562 48.351563 112.640625 74.980469 181.019531 74.980469s132.667969-26.628906 181.019531-74.980469c48.351563-48.351562 74.980469-112.640625 74.980469-181.019531s-26.628906-132.667969-74.980469-181.019531zm-325.914062 354.316406c8.453125-72.734375 70.988281-128.890625 144.894531-128.890625 38.960938 0 75.597656 15.179688 103.15625 42.734375 23.28125 23.285156 37.964844 53.6875 41.742188 86.152344-39.257813 32.878906-89.804688 52.707031-144.898438 52.707031s-105.636719-19.824219-144.894531-52.703125zm144.894531-159.789063c-42.871094 0-77.753906-34.882812-77.753906-77.753906 0-42.875 34.882812-77.753906 77.753906-77.753906s77.753906 34.878906 77.753906 77.753906c0 42.871094-34.882812 77.753906-77.753906 77.753906zm170.71875 134.425782c-7.644531-30.820313-23.585938-59.238282-46.351562-82.003906-18.4375-18.4375-40.25-32.269532-64.039063-40.9375 28.597656-19.394532 47.425781-52.160157 47.425781-89.238282 0-59.414062-48.339844-107.753906-107.753906-107.753906s-107.753906 48.339844-107.753906 107.753906c0 37.097656 18.84375 69.875 47.464844 89.265625-21.886719 7.976563-42.140626 20.308594-59.566407 36.542969-25.234375 23.5-42.757812 53.464844-50.882812 86.347656-34.410157-39.667968-55.261719-91.398437-55.261719-147.910156 0-124.617188 101.382812-226 226-226s226 101.382812 226 226c0 56.523438-20.859375 108.265625-55.28125 147.933594zm0 0" />
            </svg>
          </ProfileLinkButton>
        </MobileItemsWrapper>
      </MobileHeader>
      <MobileMenuHome active={menuOpen} handleMenu={closeMenu} />
    </>
  );
};

const HeaderWrapper = styled.div`
  padding: 0 30px;
`;

const ProfileLinkButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;

  svg {
    width: 30px;
    height: 30px;
    fill: ${colors.hamburger};
  }
`;

export default HomeNavbar;
